import { Download, FileIcon } from 'lucide-react';

type DocumentImageProps = {
  src?: string | null;
  name?: string;
  disabled?: boolean;
  handleImageChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const handleDownload = (url: string) => {
  if (url) {
    window.open(url, '_blank');
  }
};

const DocumentImage: React.FC<DocumentImageProps> = ({
  src,
  name,
  disabled,
  handleImageChange,
}) => {
  const isImage = name?.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      {isImage ? (
        <div
          onClick={() => handleDownload(src || '')}
          className="cursor-pointer rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-200 border border-gray-200">
          <img
            src={src || '/avatar_placeholder.png'}
            alt={name || 'Document'}
            className="w-[300px] h-[300px] object-cover"
          />
        </div>
      ) : (
        <div
          onClick={() => handleDownload(src || '')}
          className="cursor-pointer flex flex-col items-center justify-center w-[300px] h-[300px] rounded-lg border border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200">
          <FileIcon className="w-24 h-24 text-gray-400 mb-4" />
          <span className="text-sm text-gray-600 font-medium">
            Click to download
          </span>
        </div>
      )}
      {handleImageChange && !disabled && (
        <label className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg cursor-pointer hover:bg-blue-700 transition-colors duration-200 shadow-sm hover:shadow-md">
          <Download className="w-4 h-4" />
          <span className="text-sm font-medium">
            Upload {name || 'Image'}
          </span>
          <input
            type="file"
            accept="image/png, image/jpeg, image/gif"
            onChange={handleImageChange}
            className="sr-only"
          />
        </label>
      )}
    </div>
  );
};

export default DocumentImage;
